"use client";
import DetailInfo from "../components/DetailInfo";




const COMPONENT_PRODUCT_MAP = {
    "detail-info": DetailInfo
};

export default function ClientRenderer({ slug }) {
    // console.log(slug, "slug")
    const Component = COMPONENT_PRODUCT_MAP[slug.toLowerCase()];
    if (!Component) return <div>해당 페이지가 없습니다.</div>;

    return <Component />;
}
